export default __webpack_public_path__ + "static/media/tr.137555a8.svg";